export default __webpack_public_path__ + "static/media/cb_5.9c08eb29.png";